/**
 * lazyRetry — React.lazy() with automatic retry on chunk load failure.
 * 
 * After a new deployment, stale chunk hashes cause import() to fail.
 * This wrapper retries once, then lets the global chunk error handler
 * (chunkErrorHandler.ts) take over and trigger a full page reload.
 * 
 * Catches:
 * - "Failed to fetch dynamically imported module" (Vite)
 * - "'text/html' is not a valid JavaScript MIME type" (stale chunk → Vercel 404 → HTML fallback)
 * - "Unexpected token '<'" (browser tries to parse HTML as JS)
 * 
 * Usage:
 *   const MyPage = lazyRetry(() => import('./MyPage'));
 */

import { lazy } from 'react';

export function lazyRetry(
  importFn: () => Promise<{ default: React.ComponentType<any> }>
) {
  return lazy(() =>
    importFn().catch((error) => {
      console.warn('[lazyRetry] Import failed, retrying once...', error.message?.slice(0, 80));
      return importFn();
    })
  );
}
